import { useContext } from "react";

import { World } from "@application/contexts/world";

export const useAuthenticated = (): boolean => useContext(World).authenticated;
